/**
 * The client twin of the server's `airport_codes.fold` (which `companies.names.folded_key` builds on):
 * NFKD with the combining marks dropped, lower-cased, a few letters with no decomposition spelled
 * out, apostrophes deleted (`O'Neil` is `oneil`), every other non-letter, non-digit a space,
 * whitespace collapsed. It only decides what the typeahead offers; the server decides what matches.
 */
const LETTERS: Record<string, string> = { ø: 'o', ł: 'l', đ: 'd', ð: 'd', æ: 'ae', œ: 'oe', ı: 'i', þ: 'th', ß: 'ss' }

export function foldName(text: string | null | undefined): string {
  if (typeof text !== 'string' || !text) return ''
  const bare = text.normalize('NFKD').replace(/\p{M}/gu, '').toLowerCase()
  const spelled = bare.replace(/[øłđðæœıþß]/g, (c) => LETTERS[c])
  return spelled.replace(/['’ʼ]/g, '').replace(/[^\p{L}\p{N}]+/gu, ' ').trim()
}
